import objectifsSlice from "./objectifsSlice";

export const objectifReducers = {
  objectifsSlice,
};
